import { Attributes, ModelBase, NeoModel } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";
import { Rules } from "@singularsystems/neo-core/dist/Validation";

@NeoModel
export default class UpdateSFTPDetailCommand extends ModelBase {
    
    public staticServiceProviderSftpdetailsId: number = 0;

    public sftpSetting: string = "";

    public sftpDirectory: string = "";

    public isExportInd: boolean = false;

    @Attributes.Date(TimeZoneFormat.None)
    public nextRunDate: Date = new Date();

    public primeTimeCron: string = "";

    public lateCron: string = "";

    public isActiveInd: boolean = false;

    public isTradeOrder: boolean = false;

    public isValuation: boolean = false;

    public tradeSftpTypeId: number | null = null;

    protected override addBusinessRules(validationRules: Rules<this>): void {
        super.addBusinessRules(validationRules);

        validationRules.failWhen(command => command.sftpDirectory.length <= 0, "SFTP Directory is required.");
        validationRules.failWhen(command => command.primeTimeCron.length <= 0 && !command.isExportInd, "Prime time Cron is required.");
        validationRules.failWhen(command => command.lateCron.length <= 0 && !command.isExportInd, "Late Cron is required.");
    }

}